export type CoSignerStep = {
  key: string;
  label: string;
};

export const CO_SIGNER_STEPS: CoSignerStep[] = [
  { key: "invite", label: "Invite Owners" },
  { key: "key", label: "Set up your co-signing key" },
  { key: "review", label: "Review and confirm" },
];

type CoSignerStepperProps = {
  currentIdx: number;
  steps?: CoSignerStep[];
};

export const CoSignerStepper = ({ currentIdx, steps = CO_SIGNER_STEPS }: CoSignerStepperProps) => (
  <div
    className="MultisigStepper"
    role="list"
    aria-label="Co-signing setup progress"
    style={{ gridTemplateColumns: `repeat(${steps.length}, 1fr)` }}
  >
    {steps.map((s, i) => {
      const stateClass = i < currentIdx ? "is-complete" : i === currentIdx ? "is-current" : "";
      return (
        <div
          key={s.key}
          className={`MultisigStepper__step ${stateClass}`}
          role="listitem"
          aria-current={i === currentIdx ? "step" : undefined}
        >
          <span className="MultisigStepper__dot">
            {i < currentIdx ? (
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="black"
                strokeWidth="1.75"
                strokeLinecap="round"
                strokeLinejoin="round"
                name="check"
              >
                <path d="M20 6 9 17l-5-5"></path>
              </svg>
            ) : (
              i + 1
            )}
          </span>
          <span className="MultisigStepper__label">{s.label}</span>
        </div>
      );
    })}
  </div>
);
